import type { HelpModuleType } from "@/redux/helpModule/helpTypes";

export const helpModuleReducer = {
  resetHelpModuleError: (state: HelpModuleType) => {
    state.error = null;
  },
  resetHelpModuleSuccess: (state: HelpModuleType) => {
    state.success = null;
  },
  resetHelpModuleAddSuccess: (state: HelpModuleType) => {
    state.addSuccess = null;
  },
  resetHelpModuleEditSuccess: (state: HelpModuleType) => {
    state.editSuccess = null;
  },
  resetHelpModuleFetching: (state: HelpModuleType) => {
    state.fetching = false;
  },
  resetHelpModuleMessage: (state: HelpModuleType) => {
    state.message = "";
  },
  resetHelpModuleListing: (state: HelpModuleType) => {
    state.helpModuleList = [];
  },
  resetHelpModuleListTotal: (state: HelpModuleType) => {
    state.helpModuleTotalCount = 0;
  },
  resetHelpModuleStatusCode: (state: HelpModuleType) => {
    state.statusCode = null;
  },
  resetHelpModuleAddMessage: (state: HelpModuleType) => {
    state.addMessage = "";
  },
  resetHelpModuleEditMessage: (state: HelpModuleType) => {
    state.editMessage = "";
  },
};
